import { Injectable } from '@angular/core';
import { RecommendationModel } from 'app/core/domain/recommendation.model';
import { map, Observable } from 'rxjs';
import { RecommendationsRepository } from 'src/app/core/repositories/recommendations.repository';
import { RecommendationMapper } from './mappers/recommendation.mapper';
import { RecommendationsApisService } from './recommendations-apis.service';

@Injectable({
  providedIn: 'root',
})
export class RecommendationsImplementationRepository extends RecommendationsRepository {
  constructor(
    private recommendationsApisService: RecommendationsApisService,
    private recommendationMapper: RecommendationMapper,
  ) {
    super();
  }

  getRecommendations(): Observable<RecommendationModel[]> {
    return this.recommendationsApisService
      .getRecommendations()
      .pipe(map((products) => products.map(this.recommendationMapper.mapFrom)));
  }
}
